import { UserProfile } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';

export const PreferencesSettings = ({ profiles }: { profiles: Array<UserProfile> }) => {
    const enterpriseOptions = profiles.map((e) => ({
        value: e.profileId,
        label: e.displayName,
        disabled: false,
        secondaryText: null,
        indent: false,
        inactive: false,
    }));

    return enterpriseOptions.length > 1 ? (
        <Stack vertical spacing="300">
            <LocalizedSubsectionTitle textKey={TextKey.Preferences} />

            <SelectField
                helper={<LocalizedText textKey={TextKey.DefaultPropertyFieldHelper} />}
                options={enterpriseOptions}
                name="defaultProfileId"
                label={<LocalizedText textKey={TextKey.PropertyByDefault} />}
            />
        </Stack>
    ) : null;
};
